"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemeApi = exports.SchemeApiFactory = exports.SchemeApiFp = exports.SchemeApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * SchemeApi - axios parameter creator
 * @export
 */
const SchemeApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get all schemes visible for current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeEndpointGetAllSchemes: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/schemes/allSchemes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get scheme near given SchemeItem
         * @param {string} itemId
         * @param {string} schemeId
         * @param {number} [margin]
         * @param {Set<RequestTagValue>} [requestTagValue]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeEndpointGetNearbyScheme: (itemId_1, schemeId_1, margin_1, requestTagValue_1, ...args_2) => __awaiter(this, [itemId_1, schemeId_1, margin_1, requestTagValue_1, ...args_2], void 0, function* (itemId, schemeId, margin, requestTagValue, options = {}) {
            // verify required parameter 'itemId' is not null or undefined
            (0, common_1.assertParamExists)('schemeEndpointGetNearbyScheme', 'itemId', itemId);
            // verify required parameter 'schemeId' is not null or undefined
            (0, common_1.assertParamExists)('schemeEndpointGetNearbyScheme', 'schemeId', schemeId);
            const localVarPath = `/schemes/nearby/{schemeId}/{itemId}`
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)))
                .replace(`{${"schemeId"}}`, encodeURIComponent(String(schemeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (margin !== undefined) {
                localVarQueryParameter['margin'] = margin;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestTagValue, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get scheme meta info
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeEndpointGetSchemeMeta: (schemeId_2, ...args_3) => __awaiter(this, [schemeId_2, ...args_3], void 0, function* (schemeId, options = {}) {
            // verify required parameter 'schemeId' is not null or undefined
            (0, common_1.assertParamExists)('schemeEndpointGetSchemeMeta', 'schemeId', schemeId);
            const localVarPath = `/schemes/schemeMeta/{schemeId}`
                .replace(`{${"schemeId"}}`, encodeURIComponent(String(schemeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.SchemeApiAxiosParamCreator = SchemeApiAxiosParamCreator;
/**
 * SchemeApi - functional programming interface
 * @export
 */
const SchemeApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.SchemeApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get all schemes visible for current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeEndpointGetAllSchemes(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.schemeEndpointGetAllSchemes(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SchemeApi.schemeEndpointGetAllSchemes']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get scheme near given SchemeItem
         * @param {string} itemId
         * @param {string} schemeId
         * @param {number} [margin]
         * @param {Set<RequestTagValue>} [requestTagValue]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeEndpointGetNearbyScheme(itemId, schemeId, margin, requestTagValue, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.schemeEndpointGetNearbyScheme(itemId, schemeId, margin, requestTagValue, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SchemeApi.schemeEndpointGetNearbyScheme']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get scheme meta info
         * @param {string} schemeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeEndpointGetSchemeMeta(schemeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.schemeEndpointGetSchemeMeta(schemeId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SchemeApi.schemeEndpointGetSchemeMeta']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.SchemeApiFp = SchemeApiFp;
/**
 * SchemeApi - factory interface
 * @export
 */
const SchemeApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.SchemeApiFp)(configuration);
    return {
        /**
         * Get all schemes visible for current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeEndpointGetAllSchemes(options) {
            return localVarFp.schemeEndpointGetAllSchemes(options).then((request) => request(axios, basePath));
        },
        /**
         * Get scheme near given SchemeItem
         * @param {SchemeApiSchemeEndpointGetNearbySchemeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeEndpointGetNearbyScheme(requestParameters, options) {
            return localVarFp.schemeEndpointGetNearbyScheme(requestParameters.itemId, requestParameters.schemeId, requestParameters.margin, requestParameters.requestTagValue, options).then((request) => request(axios, basePath));
        },
        /**
         * Get scheme meta info
         * @param {SchemeApiSchemeEndpointGetSchemeMetaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemeEndpointGetSchemeMeta(requestParameters, options) {
            return localVarFp.schemeEndpointGetSchemeMeta(requestParameters.schemeId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SchemeApiFactory = SchemeApiFactory;
/**
 * SchemeApi - object-oriented interface
 * @export
 * @class SchemeApi
 * @extends {BaseAPI}
 */
class SchemeApi extends base_1.BaseAPI {
    /**
     * Get all schemes visible for current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemeApi
     */
    schemeEndpointGetAllSchemes(options) {
        return (0, exports.SchemeApiFp)(this.configuration).schemeEndpointGetAllSchemes(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get scheme near given SchemeItem
     * @param {SchemeApiSchemeEndpointGetNearbySchemeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemeApi
     */
    schemeEndpointGetNearbyScheme(requestParameters, options) {
        return (0, exports.SchemeApiFp)(this.configuration).schemeEndpointGetNearbyScheme(requestParameters.itemId, requestParameters.schemeId, requestParameters.margin, requestParameters.requestTagValue, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get scheme meta info
     * @param {SchemeApiSchemeEndpointGetSchemeMetaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemeApi
     */
    schemeEndpointGetSchemeMeta(requestParameters, options) {
        return (0, exports.SchemeApiFp)(this.configuration).schemeEndpointGetSchemeMeta(requestParameters.schemeId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SchemeApi = SchemeApi;
//# sourceMappingURL=scheme-api.js.map